import React from "react";
import "./Footer.css";
import { FaFacebookF } from "react-icons/fa";
import { BsLinkedin } from "react-icons/bs";
import { FaGithub } from "react-icons/fa";
import { BsSkype } from "react-icons/bs";

const Footer = () => {
  return (
    <footer>
      <a href="#" className="footer__logo">
        Sharmil
      </a>
      <ul className="permalinks">
        <li>
          <a href="#"></a>
        </li>
        <li>
          <a href="#about">About</a>
        </li>
        <li>
          <a href="#experience">Experience</a>
        </li>
        <li>
          <a href="#services">Services</a>
        </li>
        <li>
          <a href="#portfolio">Portfolio</a>
        </li>
        <li>
          <a href="#testimonials">Testimonials</a>
        </li>
        <li>
          <a href="#contact">Contact</a>
        </li>
      </ul>

      <div className="footer__socials">
        <a href="https://facebook.com">
          <FaFacebookF />
        </a>
        <a href="https://www.linkedin.com/in/sharmil-macwan-549bb3213/">
          <BsLinkedin />
        </a>
        <a href="https://github.com/sharmil01">
          <FaGithub />
        </a>
        <a href="https://join.skype.com/invite/unqt1JbQJTT2">
          <BsSkype />
        </a>
      </div>

      <div className="footer__copyright">
        <small>&copy; Sharmil Macwan. All rights reserved.</small>
      </div>
    </footer>
  );
};

export default Footer;
